// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3MATc"};